import store from '@/store/store';
import router from '@/router/router';
import { Component, Vue } from 'vue-property-decorator';
import { LoginService } from '@/services/login.service';

export class AuthenService extends Vue {
    public loginService: any = new LoginService();
    public tokenSubscribe: any;
    // private token = localStorage.getItem('token');

    constructor() {
        super();
    }

    get token() {
        return localStorage.getItem('token');
        // return store.getters['AuthStore/getToken'];
    }

    public refreshToken = () => {
        return setInterval(async () => {
            this.updateToken();
        }, 300000);
    }

    public async updateToken() {
        const { result, error } = await this.loginService.refreshToken(this.token);
        if (result && result.status === 200) {
            console.log('refreshToken', result.data);
            this.setToken(result.data.token);
        } else {
            this.handleError(error);
        }
    }

    public removeToken = async () => {
        const { result, error } = await this.loginService.removeToken(this.token);
        if (result) {
            console.log('removeToken [SUCCESS]', result);
        } else {
            console.log('removeToken [ERROR]', error);
        }
    }

    public authRequire = (to: any, from: any, next: any) => {
        if (this.token) {
            this.updateToken();
            this.tokenSubscribe = this.refreshToken();
            next();
        } else {
            this.clearAuth();
            next({
                name: 'login',
            });
        }
    }

    public staffRequire = (to: any, from: any, next: any) => {
        const staffData = localStorage.getItem('staffData');
        const data = JSON.parse(staffData ? staffData : '{"results":false}');
        this.setStaffData(data);
        if (data && data.results) {
            next();
        } else {
            this.openStaffModal();
            if ((from.name === 'login' || from.name === null) && to.name === 'home') {
                next();
                // when no staffData and wanna login and go to home from.name === 'login'
                // when no staffData and refresh web from.name === null
            }
            next(false);
        }
    }

    public onLogout = (to?: any, from?: any, next?: any) => {
        if (next) {
            // const confirms = confirm('Are you sure you want to log out?');
            // if (confirms) {
                this.clearAuth();
                next({
                    name: 'login',
                });
            // } else {
            //     next(false);
            // }
        } else {
            this.clearAuth();
            router.push('/login');
        }
    }

    public handleError(err: any, func?: string) {
        if (err && err.status === 401) {
            console.log(`${func}->`, err);
            this.onLogout();
        }
    }

    public clearAuth = () => {
        this.removeToken();
        localStorage.removeItem('token');
        localStorage.removeItem('kyotenCd');
        localStorage.removeItem('loginTypeKbn');
        localStorage.removeItem('staffData');
        this.resetStaffData();
        this.resetToken();

        /** 2021-08-05 sh #7329 add loginTypeKbn to store for Admin check [START] */
        this.resetLoginTypeKbn();
        /** 2021-08-05 sh #7329 add loginTypeKbn to store for Admin check [END] */

        // unsubscribe
        clearInterval(this.tokenSubscribe);
    }
    // store function
    private openStaffModal = () => {
        store.commit('RouteStore/openStaffModal');
    }

    private setStaffData = (data: any) => {
        store.dispatch('AuthStore/setStaffData', data);
    }

    private setToken = (data: any) => {
        store.dispatch('AuthStore/setToken', data);
    }

    private resetStaffData = () => {
        store.dispatch('AuthStore/resetStaffData');
    }

    private resetToken = () => {
        store.dispatch('AuthStore/resetToken');
    }

    /** 2021-08-05 sh #7329 add loginTypeKbn to store for Admin check [START] */
    private resetLoginTypeKbn = () => {
        store.dispatch('AuthStore/resetLoginTypeKbn');
    }
    /** 2021-08-05 sh #7329 add loginTypeKbn to store for Admin check [END] */
}

